import React from 'react';
import styled from 'styled-components';
import {TextField,IconButton,TableRow,TableCell} from '@material-ui/core';
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";

const OuterContainer = styled.div`
width:100%;
border-bottom:1px solid rgba(224, 224, 224, 1);
`

const Container = styled.div`
padding-top:10px;
padding-left:10px;
padding-right:10px;
padding-bottom:10px;
display:grid;
grid-template-columns: 250px 20px 400px 1fr 20px;

`;

const SDN = styled.div`
`;

const URL = styled.div`

`;

const IconsContainer = styled.div`
display:flex;
grid-template-columns:60px 25px 60px;
justify-content:flex-start;
`;





const ActionItemAlternateSdnV2 = ({action,context,onValueChanged}) => {

    const [alternateSdn,setAlternateSdn] = React.useState(action.alternateSdn );
    const [alternateUrl,setAlternateUrl] = React.useState(action.alternateUrl );

    return ( 
            <TableRow>
                <TableCell colSpan={2}>
                <SDN>
                <TextField 
                    label="Alternate SDN" 
                    value={alternateSdn} 
                    onChange={event => setAlternateSdn(event.target.value)} 
                    fullWidth 
                    margin="normal" 
                    variant="outlined"
                     />
                     
                </SDN>
                </TableCell>
                <TableCell colSpan={4}>
                <URL>
                <TextField 
                    label="URL" 
                    value={alternateUrl} 
                    onChange={event => setAlternateUrl(event.target.value)} 
                    fullWidth 
                    margin="normal" 
                    variant="outlined"
                     />
                     
                </URL>
                </TableCell>

                <TableCell colSpan={3}>

                <IconsContainer>
                <IconButton
                     disabled={!alternateSdn && !action.alternateSdn} 
                     color="primary" 
                     onClick={() => {
                        if(!alternateSdn) {
                            onValueChanged({alternateSdn,alternateUrl:''});
                        } else {
                            onValueChanged({alternateSdn,alternateUrl});
                        }
                    }}
                 >
                    <CheckIcon />
                </IconButton>
                <div/>
                <IconButton style={{paddingLeft:10}} color="primary" onClick={() =>context.setAlternateSdnAction(null) }>
                    <CloseIcon />
                </IconButton>
                </IconsContainer>
                <div/>
                </TableCell>

            </TableRow>
            
)
}

export default ActionItemAlternateSdnV2;